<template>
  <aside v-if="Object.keys(groupedAmenities).length" class="widget mt-8">
    <div class="widget-title">
      <h6>{{ $t('property_detail.property.amenities.title') }}</h6>
    </div>

    <div
      v-for="(items, groupKey) in groupedAmenities"
      :key="groupKey"
      class="mb-3"
    >
      <h6 class="text-sm fw-medium mb-2">
        {{ $t(`property_detail.property.amenities.labels.${groupKey}`, groupLabels[groupKey] || groupKey) }}
      </h6>
      <div class="tag-cloud">
        <a
          v-for="feature in items"
          :key="feature.key"
          href="#"
        >
          {{ feature.label }}
        </a>
      </div>
    </div>
  </aside>

  <div v-else class="text-center text-gray-500 mt-4">
    {{ $t('property_detail.property.amenities.empty') }}
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  property: {
    type: Object,
    required: true
  }
})

const values = computed(() => props.property.amenities || {})
const configGroups = computed(() => props.property.amenities_config?.groups || {})
const groupLabels = computed(() => props.property.amenities_config?.labels || {})

const groupedAmenities = computed(() => {
  const result = {}

  Object.entries(configGroups.value).forEach(([groupKey, items]) => {
    const activeItems = items
      .filter(item => {
        const val = values.value[item.key]
        return val === true || (item.type === 'select' && val && item.options?.[val])
      })
      .map(item => {
        const val = values.value[item.key]
        if (item.type === 'select') {
          return {
            key: item.key,
            label: item.options?.[val] || val
          }
        } else {
          return {
            key: item.key,
            label: item.label
          }
        }
      })

    if (activeItems.length > 0) {
      result[groupKey] = activeItems
    }
  })

  return result
})
</script>

<style scoped>
.tag-cloud a {
  display: inline-block;
  margin: 4px;
  padding: 6px 12px;
  background-color: #f1f5f9;
  color: #333;
  font-size: 0.875rem;
  border-radius: 6px;
  text-decoration: none;
  transition: 0.2s;
}

.tag-cloud a:hover {
  background-color: #e0e7ef;
  color: #000;
}
</style>
